module.exports = __webpack_public_path__ + "img/Feature_Panel_eBike_base_assist_off.d28fc9a7.svg";